import { alpha } from '@mui/material/styles';
import { tss } from 'tss-react/mui';

export const useStyles = tss
  .withParams<{ messagesHeight?: number | null }>()
  .create(({ theme, messagesHeight = 385 }) => ({
    dialog: {
      '& .MuiDialog-container': {
        '& .MuiPaper-root': {
          width: '450px',
          maxHeight: '1000px',
          overflowY: 'unset',
          overflowX: 'hidden',
        },
      },
    },
    dialogTitle: {
      textAlign: 'center',
      color: theme.palette.extendedGrey?.darker,
      fontSize: '18px',
      padding: '30px 30px 15px 30px',
    },
    customizedButton: {
      position: 'absolute',
      right: '15px',
      top: '15px',
      padding: 0,
    },
    dialogContent: {
      padding: '0px 30px',
      overflowY: 'hidden',
      // The dialog paper is a fixed 450px, so anything wider than the content box used to
      // push a horizontal scrollbar onto the whole popup. The message list scrolls on its
      // own, so nothing here needs horizontal room.
      overflowX: 'hidden',
    },
    dialogActions: {
      '.MuiButton-contained.Mui-disabled.MuiButton-containedPrimary': {
        background: alpha(theme.palette.primary.main, 0.3),
        color: theme.palette.common.white,
      },
      '.MuiButton-contained.Mui-disabled.MuiButton-containedError': {
        background: theme.palette.error.light,
        color: theme.palette.common.white,
      },
    },
    chatBox: {
      width: '100%',
      height: '100%',
      minHeight: 0,
    },
    chatBoxMessages: {
      padding: '20px 20px 20px 28px',
      width: '100%',
      height: messagesHeight ?? '100%',
      overflow: 'scroll',
      borderRadius: '0 8px 8px 8px',
      backgroundColor: theme.palette.extendedGrey?.lighter,
    },
    dialogGridContent: {
      display: 'flex',
      height: '100%',
      minHeight: 0,
      justifyContent: 'space-between',
      alignContent: 'space-between',
      '> .MuiGrid-item': {
        height: '100%',
        minHeight: 0,
        overflow: 'hidden',
      },
      '.MuiTabs-scroller.MuiTabs-fixed': {
        '.MuiTabs-flexContainer': {
          '.MuiTab-root': {
            borderRadius: '8px 8px 0 0',
            '&.Mui-selected': {
              backgroundColor: theme.palette.extendedGrey?.lighter,
              color: theme.palette.extendedGrey?.darker,
            },
          },
        },
        '.MuiTabs-indicator': {
          backgroundColor: 'transparent',
        },
      },
    },
  }));
